<!--<ng-template infoBannerHost></ng-template>-->
<ng-container *ngIf="showDemoEnvironmentBanner; else testBanner">
    <div class="environment-banner-demo">
        {{environmentBannerText || ('layout.environmentBanner.demo' | translate)}}
    </div>
</ng-container>

<ng-template #testBanner>
    <ng-container *ngIf="showTestEnvironmentBanner">
        <div class="environment-banner-test">
            {{environmentBannerText || ('layout.environmentBanner.test' | translate)}}
        </div>
    </ng-container>
</ng-template>

<u2b-welcome-splash></u2b-welcome-splash>
<u2b-system-notifications></u2b-system-notifications>

<div class="app-container">
    <fuse-progress-bar></fuse-progress-bar>

    <layout></layout>
</div>
